import { config } from "@shared/config";

export const defaultHeaders = () => ({
  "Cache-Control": "no-cache, no-store, must-revalidate",
  Pragma: "no-cache",
  Expires: "0",
  "X-Application-Name": config.VITE_MC_APP_NAME ?? "MobilityCare",
  "X-Env-Mode": config.VITE_CONFIG_MODE ?? "PROD",
});
